"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PageController = _ref => {
  let {
    controller,
    dispatch,
    height = "100%",
    margin = "0px"
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const containerProps = {
    height,
    margin
  };
  const {
    currentPage = 1,
    lastPage = 1
  } = controller ? controller.getData() : {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [currentPage !== 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        icon: "first_page",
        margin: "0px 10px 0px 0px",
        size: 16,
        onClick: () => controller.getFirstPage(dispatch)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        icon: "chevron_left",
        margin: "0px 10px 0px 0px",
        size: 16,
        onClick: () => controller.getPrevPage(dispatch)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Item, {
      print: true,
      children: [currentPage, " ", t('de'), " ", lastPage]
    }), currentPage !== lastPage && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        icon: "chevron_right",
        margin: "0px 0px 0px 10px",
        size: 16,
        onClick: () => controller.getNextPage(dispatch)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        icon: "last_page",
        margin: "0px 0px 0px 10px",
        size: 16,
        onClick: () => controller.getLastPage(dispatch)
      })]
    })]
  }));
};
PageController.propTypes = {
  controller: _propTypes.default.object,
  dispatch: _propTypes.default.func,
  height: _propTypes.default.string,
  margin: _propTypes.default.string
};
var _default = exports.default = PageController;